import { Typography, Button, Box, Grid } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { UsersClient, UserWithOrganizationResponseDTO, OrganizationsClient } from '../generated/ApiClient'
import MUIDataTable from "mui-datatables";
import { Link as RouterLink, RouteComponentProps } from 'react-router-dom';
import { Admin, useIsUserInRoles, UserFriendlyRoleNames } from '../hooks/useIsUserInRoles';
import { useDispatch } from 'react-redux';
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { tableOptions as options } from '../common/Shared'

interface UsersTableData {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    azureId: string;
}

type props = {
    organizationId: string;
}

export default function OrganizationUsers(props: props) {
    const [usersData, setUsersData] = useState<UsersTableData[]>([]);
    const organizationId = props.organizationId
    const isAdmin = useIsUserInRoles(Admin)

    const tableOptions = {
        ...options,
        selectableRowsHideCheckboxes: !isAdmin,
        onRowsDelete: ((rowsDeleted: { lookup: any; data: { index: number; dataIndex: number; }[]; }, data: UsersTableData[]) => {
            const selectedIndexs = rowsDeleted.data.map((row) => row.dataIndex);
            const userIds = selectedIndexs.map((index) => usersData[index].azureId);
            removeUsers(userIds);
        })
    }

    const dispatch = useDispatch()

    const removeUsers = async (userIds: string[]) => {
        try {
            await Promise.all(userIds.map((userId) => removeUser(userId)));
            dispatch(snackbar.addMessage({ title: "Success", message: `Users successfully removed`, alertType: 'success' }))
            const newUsersData = usersData.filter(x => !userIds.includes(x.azureId));
            setUsersData(newUsersData);
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }
    const removeUser = async (userId: string) => {
        try {
            await new OrganizationsClient().deleteUser(organizationId, userId);
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }

    const columns = [
        {
            name: "firstName",
            label: "First Name",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "lastName",
            label: "Last Name",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "role",
            label: "Role",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: 'detailsButton',
            label: 'View',
            options: {
                sort: false,
                filter: false,
                customBodyRenderLite: (dataIndex: number) => {
                    const link = `/users/${usersData[dataIndex].azureId}`;
                    return <Button component={RouterLink} variant='contained' size='small' to={link}>View</Button>
                }
            }
        },
    ];

    function toTableData(userData: UserWithOrganizationResponseDTO) {
        return {
            firstName: userData.givenName || " N/A ",
            lastName: userData.surname || " N/A ",
            email: userData.userName || " N/A ",
            role: UserFriendlyRoleNames[userData.role.Case],
            azureId: userData.azureId || "N/A"
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const usersData = await new OrganizationsClient().getManyUsersAll(organizationId);
            setUsersData(usersData.map(toTableData));
        }
        fetchData();
    }, [organizationId])

    return (
        <>
            {isAdmin &&
                <Grid container item direction='column' spacing={2} alignItems='flex-end'>
                    <Box my={2}>
                        <Button component={RouterLink} variant='contained' color='primary' size='medium' to={`/organizations/${organizationId}/addMember`}>+ Add</Button>
                    </Box>
                </Grid>}
            <MUIDataTable
                title={""}
                data={usersData}
                columns={columns}
                options={tableOptions}
            />
        </>
    )
}